import styled from 'styled-components';

/**
 * Where a CSS-drawn chart (RadialPercent, ProgressRow, SegmentedDistributionBar) shows its hover
 * readout: centred above an anchor point, out of the pointer's way and out of any overflow clip of
 * the chart itself. It carries no look of its own - the caller's node is the box, in the screen's
 * own palette (PLA-9674).
 */
export const HoverTooltipSlot = styled.div`
  position: absolute;
  bottom: calc(100% + 6px);
  z-index: 2;
  transform: translateX(-50%);
  white-space: nowrap;
  pointer-events: none;
`;
